import { render } from "./Btn.vue?vue&type=template&id=69c8f33c&scoped=true"
import script from "./Btn.vue?vue&type=script&lang=js"
export * from "./Btn.vue?vue&type=script&lang=js"

import "./Btn.vue?vue&type=style&index=0&id=69c8f33c&lang=css"
import "./Btn.vue?vue&type=style&index=1&id=69c8f33c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c8f33c"]])

export default __exports__